import Video from '../components/Video';

/**
 * Initializes all videos on the page that have the data-video attribute
 * Lazy loads videos as they scroll into view
 * @param {HTMLElement} [container=document] - Optional container to limit video initialization scope
 * @returns {Function} Function to cleanup observer and videos
 */
export default function initVideos(container = document) {
  const videos = [];
  const videoElements = container.querySelectorAll('[data-video]');
  let observer;

  if (videoElements.length > 0) {
    // Create intersection observer
    observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const videoEl = entry.target;
            const video = new Video(videoEl);
            videos.push(video);

            // Stop observing this element
            observer.unobserve(videoEl);
          }
        });
      },
      {
        root: null,
        rootMargin: '200px', // Load videos slightly before they come into view
        threshold: 0,
      },
    );

    // Start observing all video elements
    videoElements.forEach(videoEl => {
      observer.observe(videoEl);
    });
  }

  // Return cleanup function
  return function cleanup() {
    // Disconnect observer
    if (observer) {
      observer.disconnect();
    }

    // Unload all videos
    if (videos && videos.length > 0) {
      videos.forEach(video => {
        if (video && typeof video.unload === 'function') {
          video.unload();
        }
      });
    }
  };
}
